<template>
  <div id="app" style="height:100%;" >
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="view" style="height:100%;"></router-view>
      <!-- <transition :name="transitionName">
      <router-view v-if="$route.meta.keepAlive" class="child-view view" style="height:100%;"></router-view>
      </transition> -->
    </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" class="view" style="height:100%;"></router-view>
    <!-- <transition :name="transitionName">
    <router-view v-if="!$route.meta.keepAlive" class="child-view view" style="height:100%;"></router-view>
     </transition> -->
    <v-toast :text="toast.message" v-show="toast.show"/>
    <v-loading :text = "loading.message" v-show="loading.show"/>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        transitionName: 'slide-left',
        showLoading: false,
        toast: {
          show: false,
          message: '',
          timer: undefined
        },
        loading: {
          show: false,
          message: ''
        }
      }
    },
    // beforeRouteUpdate (to, from, next) {
    //   console.log('老子在撤退')
    //   let isBack = this.$router.isBack
    //   if (isBack) {
    //     this.transitionName = 'slide-right'
    //   } else {
    //     this.transitionName = 'slide-left'
    //   }
    //   this.$router.isBack = false
    //   next()
    // },
    created () {
      window.$app = this
    },
    mounted () {
      let loading = document.getElementById('bowl-wrapper')
      if (loading.parentNode) {
        loading.parentNode.removeChild(loading)
      }
      this.$on('toast', (message, autoCancel) => {
        if (this.toast.timer) {
          clearTimeout(this.toast.timer)
          this.toast.timer = undefined
        }
        this.toast.message = message
        this.toast.show = true
        if (autoCancel) {
          this.toast.timer = setTimeout(() => {
            this.toast.message = undefined
            this.toast.show = false
          }, 2000)
        } else {

        }
      })
      this.$on('closeToast', () => {
        this.toast.message = undefined
        this.toast.show = false
      })
      this.$on('loading', message => {
        this.loading.show = (message !== null)
        this.loading.message = message
      })
    }
  }
</script>

<style lang="stylus">
@import "./css/var.styl"
.child-view {
  position: absolute;
  width:100%;
  transition: all .8s cubic-bezier(.55,0,.1,1);
  }
.slide-left-enter, .slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate(50px, 0);
    transform: translate(50px, 0);
  }
  .slide-left-leave-active, .slide-right-enter {
    opacity: 0;
    -webkit-transform: translate(-50px, 0);
    transform: translate(-50px, 0);
  }
</style>



// WEBPACK FOOTER //
// App.vue?fab83a88